import { COVERAGE_TYPE_LABELS } from '@/models/insuranceCoverage'
import { type CoverageOutcome, type MinimalQuoteCardStage, QuoteCardStage } from './quoteCardTypes'

/** What a line without a price says where a priced row prints its premium. */
const OUTCOME_LABEL: Record<MinimalQuoteCardStage, string> = {
  [QuoteCardStage.PREPARING]: 'Preparing',
  [QuoteCardStage.APPLICATION_SENT]: 'Waiting for quote',
  [QuoteCardStage.DECLINED]: 'Declined',
  [QuoteCardStage.ERROR]: 'Declined',
  [QuoteCardStage.UNAVAILABLE]: 'Declined',
  [QuoteCardStage.REQUEST_TO_BIND]: 'Checkout in progress',
  [QuoteCardStage.BOUND]: 'Coverage is active',
}

/** One line the carrier answered on without a price — a coverage row with a status, no terms. */
export function CoverageOutcomeRow({ outcome }: { outcome: CoverageOutcome }) {
  return (
    <div className="bg-ink-50/60 flex items-center justify-between gap-3 rounded-xl p-3">
      <span className="text-muted-foreground text-md font-semibold">
        {COVERAGE_TYPE_LABELS[outcome.type]}
      </span>
      <span className="text-muted-foreground shrink-0 text-sm">{OUTCOME_LABEL[outcome.stage]}</span>
    </div>
  )
}
